import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { lastAnswerIdSelector } from '@selectors/user';
import { AnswerPaths, Paths } from '@constants/paths';

/*
  The component is for redirection to the latest answer of the user
 */
export const AnswerChecker = () => {
  const navigate = useNavigate();
  const lastAnswerId = useSelector(lastAnswerIdSelector);
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      return;
    } else if (lastAnswerId) {
      navigate(`/${AnswerPaths.ANSWER}/${lastAnswerId}`);
    } else {
      navigate(Paths.NOT_FOUND);
    }
  }, [lastAnswerId]);

  return <Outlet />;
};
